import { EmployeeAgreementBO } from "./document/document.model";

export class employeeOnboardBO {
  edit: boolean = false;
  onboardingId: string;
  datalist: any;
  addnew: boolean = false;
  add: boolean = false;
  profileData: any;
  statusinfo: any;
  signName: any;
  signature: any;
  onboardingUserNote: string;
  disable: string;
  clientid: string;
  employeeid: string;
  agreementId:string|null;
  templateId:string;
  employeestatus:string;
  employerstatus:string
  iscompleted:boolean=false;
  print:boolean=true;
  statusLid:string;

}

export class PageNavigateBo {
  Jobseekerpagename: string = "";
  savedpage: number = 0;
  bool = false;
  enableDoc = false;
  data: any;
  close = false;
}
export class SendToUserBO {
  id: string;
  agencyNote: string;
  employeeagreementId: string;
}

export class SendToClientBO {
  id: string;
  portalLink: string;
  agencyNote: string;
  employeeagreementId: string;
  documentValue: EmployeeAgreementBO
}

export class SendToEmployeeBO {
  id: string;
  portalLink: string;
  agencyNote: string;
  employeeagreementId: string;
  documentValue: EmployeeAgreementBO
}

export class functionpermission {

}